<template>
  <b-row>
    <b-col
      cols="3"
      style="padding-right:1rem"
    >
      <b-form-group label="CNAE principal">
        <b-input
          v-model="cnaePrincipal.idIBGE"
          :state="erro ? false:null"
          @blur="buscarDescricao()"
        />

        <small
          v-if="erro"
          class="text-danger"
        >Subclass do CNAE não encontrado</small>
      </b-form-group>
    </b-col>
    <b-col
      cols="9"
      class="pl-0"
    >
      <b-form-group label="Descrição">
        <b-input
          :value="cnaePrincipal.descricao"
          disabled
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import { mapGetters } from 'vuex'
import api from './api'

export default {
  name: 'CNAE',
  components: {
  },
  data() {
    return {
      erro: false,
    }
  },
  computed: {
    ...mapGetters('empresa', ['cnaePrincipal']),
  },
  methods: {
    buscarDescricao() {
      this.erro = false
      api.buscarCNAE(this.cnaePrincipal.idIBGE)
        .then(payload => {
          const desc = payload.data.length === 0 ? null : payload.data[0].descricao
          if (!desc) {
            this.erro = true
          } else {
            this.$set(this.cnaePrincipal, 'descricao', desc)
          }
        })
        .catch(err => {
          this.erro = true
          throw err
        })
    },
  },
}
</script>
